import { render, staticRenderFns } from "./editShopConfig.vue?vue&type=template&id=7c6b7a3c&scoped=true"
import script from "./editShopConfig.vue?vue&type=script&lang=js"
export * from "./editShopConfig.vue?vue&type=script&lang=js"
import style0 from "./editShopConfig.vue?vue&type=style&index=0&id=7c6b7a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b7a3c",
  null
  
)

export default component.exports